import {
  PurchaseOrdersDetailsActions,
  PurchaseOrdersDetailsGetters,
  PurchaseOrdersDetailsMutations
} from './purchase-order-details-keys';
import { TolErrorsActions } from '@/app/features/tol-errors/tol-errors.keys';
import { TolMessagesActions } from '@/app/features/tol-messages/tol-messages.keys';
import i18n from '@/i18n';
import { purchaseOrderDetailsService } from './purchase-order-details.service';
import router from '@/router';
export const getDefaultState = () => {
  return {
    isLoading: true,
    isItemLoaded: false,
    isPurchaseOrderModified: false,
    currentPurchaseOrder: {
      POItems: [],
      client_id: null,
      client_name: null,
      client_number: null,
      created_at: null,
      created_by_id: null,
      end_client_id: null,
      end_client_name: null,
      end_date: null,
      funds_issued: null,
      funds_remaining: null,
      id: null,
      percentage_remaining: null,
      purchase_order_number: null,
      reference_number: null,
      start_date: null,
      status: null
    },
    purchaseOrderValidationErrors: {},
    itemNumberDetails: {},
    currentPurchaseOrderHistories: [],
    fullAuditTrials: [],
    currentPurchaseOrderAssignments: [],
    currentPurchaseOrderPreviousAssignments: [],
    purchaseOrderAssignmentSortOrder: {
      sortBy: 'payroll_number',
      sortDirection: 'asc'
    },
    purchaseOrderPreviousAssignmentSortOrder: {
      sortBy: 'payroll_number',
      sortDirection: 'asc'
    }
  };
};

export const purchaseOrderDetailsStore = {
  state: getDefaultState(),
  getters: {
    [PurchaseOrdersDetailsGetters.CurrentPurchaseOrder]: state => {
      return state.currentPurchaseOrder;
    },
    [PurchaseOrdersDetailsGetters.GetStatuses]: state => {
      return state.statuses.map(status => status.value);
    },
    [PurchaseOrdersDetailsGetters.GetPoItems]: state => {
      return state.itemNumberDetails;
    },
    [PurchaseOrdersDetailsGetters.IsItemLoaded]: state => {
      return state.isItemLoaded;
    },
    [PurchaseOrdersDetailsGetters.PurchaseOrderHistories]: state => {
      return state.currentPurchaseOrderHistories;
    },
    [PurchaseOrdersDetailsGetters.SelectedHistoryRecord]: state => poId => {
      return state.currentPurchaseOrderHistories.filter(
        historyRecord => historyRecord.id === poId
      )[0];
    },
    [PurchaseOrdersDetailsGetters.PurchaseOrderFullAuditTrial]: state => {
      return state.fullAuditTrials;
    },
    [PurchaseOrdersDetailsGetters.PurchaseOrderAssignments]: state => {
      return state.currentPurchaseOrderAssignments;
    },
    [PurchaseOrdersDetailsGetters.PurchaseOrderAssignmentsSortOrder]: state => {
      return state.purchaseOrderAssignmentSortOrder;
    },
    [PurchaseOrdersDetailsGetters.PurchaseOrderPreviousAssignments]: state => {
      return state.currentPurchaseOrderPreviousAssignments;
    },
    [PurchaseOrdersDetailsGetters.PurchaseOrderPreviousAssignmentsSortOrder]: state => {
      return state.purchaseOrderPreviousAssignmentSortOrder;
    },
    [PurchaseOrdersDetailsGetters.IsLoading]: state => {
      return state.isLoading;
    }
  },

  mutations: {
    [PurchaseOrdersDetailsMutations.ResetPurchaseOrder]: function(state) {
      Object.assign(state, getDefaultState());
    },
    [PurchaseOrdersDetailsMutations.SetLoading]: (state, isLoading = true) => {
      state.isLoading = isLoading;
    },
    [PurchaseOrdersDetailsMutations.SerPurchaseOrderDetails]: (state, purchaseOrder) => {
      state.currentPurchaseOrder = purchaseOrder;
      state.isOnScreenTesEmployeeModified = false;
    },
    [PurchaseOrdersDetailsMutations.SetPoItemDetails]: (state, poItem) => {
      state.itemNumberDetails = poItem;
      state.isItemLoaded = true;
    },
    [PurchaseOrdersDetailsMutations.SetPurchaseOrderHistories]: (state, histories) => {
      state.currentPurchaseOrderHistories = histories;
    },
    [PurchaseOrdersDetailsMutations.SetPurchaseOrderFullAuditTrial]: (state, auditTrials) => {
      state.fullAuditTrials = auditTrials;
    },
    [PurchaseOrdersDetailsMutations.SetPurchaseOrderAssignments]: (state, assignments) => {
      state.currentPurchaseOrderAssignments = assignments;
    },
    [PurchaseOrdersDetailsMutations.SetPoOrdersAssignmentSortOrder]: (state, sortOrder) => {
      state.purchaseOrderAssignmentSortOrder = sortOrder;
    },
    [PurchaseOrdersDetailsMutations.SetPurchaseOrderPreviousAssignments]: (state, assignments) => {
      state.currentPurchaseOrderPreviousAssignments = assignments;
    },
    [PurchaseOrdersDetailsMutations.SetPoOrdersPreviousAssignmentSortOrder]: (state, sortOrder) => {
      state.purchaseOrderPreviousAssignmentSortOrder = sortOrder;
    }
  },

  actions: {
    [PurchaseOrdersDetailsActions.ResetCurrentPurchaseOrderDetails]: function({
      commit,
      dispatch
    }) {
      dispatch(TolErrorsActions.ClearAll);
      commit(PurchaseOrdersDetailsMutations.ResetPurchaseOrder);
    },
    [PurchaseOrdersDetailsActions.RetrievePurchaseOrderDetails]: (
      { commit, dispatch },
      reference_number
    ) => {
      if (reference_number === 'create') {
        commit(
          PurchaseOrdersDetailsMutations.SerPurchaseOrderDetails,
          getDefaultState().currentPurchaseOrder
        );
      } else {
        purchaseOrderDetailsService
          .retrievePurchaseOrder(reference_number)
          .then(purchaseOrder => {
            commit(PurchaseOrdersDetailsMutations.SerPurchaseOrderDetails, purchaseOrder);
            dispatch(PurchaseOrdersDetailsActions.RetrievePurchaseOrderHistories, reference_number);
            dispatch(
              PurchaseOrdersDetailsActions.RetrievePurchaseOrderFullAuditTrial,
              reference_number
            );
            dispatch(
              PurchaseOrdersDetailsActions.RetrievePurchaseOrderAssignemnts,
              reference_number
            );
            dispatch(
              PurchaseOrdersDetailsActions.RetrievePurchaseOrderPreviousAssignemnts,
              reference_number
            );
          })
          .then(() => {
            dispatch(TolErrorsActions.ClearAll);
          })
          .catch(error => {
            dispatch(TolErrorsActions.SetError, {
              error,
              message: i18n.t('purchaseOrders.details.errors.retrievePurchaseOrder')
            });
            commit(PurchaseOrdersDetailsMutations.SetLoading, false);
          });
      }
    },

    [PurchaseOrdersDetailsActions.RetrievePurchaseOrderHistories]: (
      { commit },
      reference_number
    ) => {
      return purchaseOrderDetailsService.retrievePOHistories(reference_number).then(histories => {
        commit(PurchaseOrdersDetailsMutations.SetPurchaseOrderHistories, histories);
      });
    },

    [PurchaseOrdersDetailsActions.RetrievePurchaseOrderFullAuditTrial]: (
      { commit },
      reference_number
    ) => {
      return purchaseOrderDetailsService
        .retrievePOFullAuditTrial(reference_number)
        .then(auditTrials => {
          commit(PurchaseOrdersDetailsMutations.SetPurchaseOrderFullAuditTrial, auditTrials);
        });
    },
    [PurchaseOrdersDetailsActions.FilterAuditTrial]: (
      { commit },
      { filteredItemNo, reference_number }
    ) => {
      return purchaseOrderDetailsService
        .retrievePOFullAuditTrial(reference_number, filteredItemNo)
        .then(auditTrials => {
          commit(PurchaseOrdersDetailsMutations.SetPurchaseOrderFullAuditTrial, auditTrials);
        });
    },
    [PurchaseOrdersDetailsActions.UpdatePurchaseOrderAssignmentsSortOrder]: (
      { state, commit, dispatch },
      sortOrder
    ) => {
      commit(PurchaseOrdersDetailsMutations.SetPoOrdersAssignmentSortOrder, sortOrder);
      dispatch(
        PurchaseOrdersDetailsActions.RetrievePurchaseOrderAssignemnts,
        state.currentPurchaseOrder.reference_number
      );
    },
    [PurchaseOrdersDetailsActions.UpdatePurchaseOrderPreviousAssignmentsSortOrder]: (
      { state, commit, dispatch },
      sortOrder
    ) => {
      commit(PurchaseOrdersDetailsMutations.SetPoOrdersPreviousAssignmentSortOrder, sortOrder);
      dispatch(
        PurchaseOrdersDetailsActions.RetrievePurchaseOrderPreviousAssignemnts,
        state.currentPurchaseOrder.reference_number
      );
    },
    [PurchaseOrdersDetailsActions.RetrievePurchaseOrderAssignemnts]: (
      { commit, state },
      reference_number
    ) => {
      return purchaseOrderDetailsService
        .retrievePOAssignments(reference_number, state.purchaseOrderAssignmentSortOrder)
        .then(assignments => {
          commit(PurchaseOrdersDetailsMutations.SetPurchaseOrderAssignments, assignments);
        });
    },
    [PurchaseOrdersDetailsActions.RetrievePurchaseOrderPreviousAssignemnts]: (
      { commit, state },
      reference_number
    ) => {
      return purchaseOrderDetailsService
        .retrievePOPreviousAssignments(
          reference_number,
          state.purchaseOrderPreviousAssignmentSortOrder
        )
        .then(assignments => {
          commit(PurchaseOrdersDetailsMutations.SetPurchaseOrderPreviousAssignments, assignments);
          commit(PurchaseOrdersDetailsMutations.SetLoading, false);
        });
    },
    [PurchaseOrdersDetailsActions.ManualIssueDeplete]: ({ dispatch }, poItemDetails) => {
      purchaseOrderDetailsService
        .saveItemDetails(poItemDetails)
        .then(status => {
          if (status.message === 'success') {
            dispatch(PurchaseOrdersDetailsActions.RetrievePurchaseOrderDetails, status.data);
            router.replace({ path: `/purchase-orders/${status.data}` }).catch(error => {
              if (error.name !== 'NavigationDuplicated') {
                dispatch(TolErrorsActions.SetError, { error });
              }
            });
          } else {
            const messages = Object.values(status.errors);
            let items = [];
            for (let item of messages) {
              items = items.concat(item);
            }
            dispatch(TolErrorsActions.SetError, { items });
          }
        })
        .catch(error => {
          dispatch(TolErrorsActions.SetError, {
            error,
            message: i18n.t('purchaseOrders.details.errors.retrievePurchaseOrder')
          });
        });
    },

    [PurchaseOrdersDetailsActions.SaveNewLineItem]: ({ dispatch }, newLineItem) => {
      purchaseOrderDetailsService
        .saveNewItem(newLineItem)
        .then(status => {
          if (status.message === 'success') {
            dispatch(PurchaseOrdersDetailsActions.RetrievePurchaseOrderDetails, status.data);
            router.replace({ path: `/purchase-orders/${status.data}` }).catch(error => {
              if (error.name !== 'NavigationDuplicated') {
                dispatch(TolErrorsActions.SetError, { error });
              }
            });
          } else {
            const messages = Object.values(status.errors);
            let items = [];
            for (let item of messages) {
              items = items.concat(item);
            }
            dispatch(TolErrorsActions.SetError, { items });
          }
        })
        .catch(error => {
          dispatch(TolErrorsActions.SetError, {
            error,
            message: i18n.t('purchaseOrders.details.errors.retrievePurchaseOrder')
          });
        });
    },

    [PurchaseOrdersDetailsActions.SavePurchaseOrder]: ({ dispatch }, poData) => {
      return purchaseOrderDetailsService
        .savePurchaseOrder(poData)
        .then(status => {
          if (status.message === 'success') {
            dispatch(PurchaseOrdersDetailsActions.RetrievePurchaseOrderDetails, status.data);
            dispatch(TolMessagesActions.SetMessages, {
              text: i18n.t('purchaseOrders.details.successMessage')
            });
            router.replace({ path: `/purchase-orders/${status.data}` }).catch(error => {
              if (error.name !== 'NavigationDuplicated') {
                dispatch(TolErrorsActions.SetError, { error });
              }
            });
          } else {
            const messages = Object.values(status.errors);
            let items = [];
            for (let item of messages) {
              items = items.concat(item);
            }
            dispatch(TolErrorsActions.SetError, { items });
          }
        })
        .catch(error => {
          dispatch(TolErrorsActions.SetError, {
            error,
            message: i18n.t('purchaseOrders.details.errors.retrievePurchaseOrder')
          });
        });
    }
  }
};
